<template lang="pug">
.footer-nav.fixed-bottom
  .paralay-selection-wrapper(v-if="betparlayCount > 0" @click="showMe()")
    .left
      .selection-wrap
        span {{ $t("ui.parlay_slip_selection")}}
        span.selection {{ betparlayCount }}
    .right
      .odds-wrap
        span {{ $t("ui.odds") }} :
        span.odds.ml-1 {{ multi }}
  .footer-wrap.d-flex.justify-content-around
    router-link.footer-single(v-if="!whiteLabel && !isWorldcupEvent" to="/lobby")
      .footer-icon(:class="{ 'active' : $route.name == 'lobby' }")
        i.custom-icon
          img(:src="($route.name == 'lobby') ? '/images/footer_nav/home_hover.svg' : '/images/footer_nav/home.svg'")
        .footer-name {{ $t("ui.home") }}
    #dd-prematch.footer-single.dropdown
      .dd.footer-icon(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false' :class="{ 'active' : !['live','upcoming'].includes(menu0) && $route.name == 'prematch' }")
        i.custom-icon
          img(:src="($route.name == 'prematch') ? '/images/footer_nav/sports_hover.svg' : '/images/footer_nav/sports.svg'")
        .footer-name {{ $t("ui.sports") }}
      ul.dropdown-menu(aria-labelledby='dd-prematch' x-placement='bottom-start')
        li.d-item
          template(v-if="$store.getters.currencyCode == 'BDT'")
            a(href="javascript:void(0);" @click="selectFooterSport(12)" :class="menu2 == 1 && $route.name != 'allsports' ? 'active' : ''")
              i.icon-prematch
                img(:src="'/images/icon-sport-svg/' + getSportsImage(12)")
              | {{ $t("ui.cricket") }}
          template(v-else)
            a(href="javascript:void(0);" @click="selectFooterSport(1)" :class="menu2 == 1 && $route.name != 'allsports' ? 'active' : ''")
              i.icon-prematch
                img(:src="'/images/icon-sport-svg/' + getSportsImage(1)")
              | {{ $t("ui.soccer") }}
        li.d-item
          a(href="javascript:void(0);" @click="selectFooterSport(2)" :class="menu2 == 2 && $route.name != 'allsports' ? 'active' : ''")
            i.icon-prematch
              img(:src="'/images/icon-sport-svg/' + getSportsImage(2)")
            | {{ $t("ui.basketball") }}
        li.d-item(v-if="esports2")
          router-link(to="/slots?mode=3" target="_blank" onclick="window.open(this.href,'_blank','status=no,toolbar=no,menubar=no,location=no');return false;")
            i.icon-prematch
              img(:src="'/images/icon-sport-svg/' + getSportsImage(20)")
            | {{ $t("ui.esports2") }}
        li.d-item
          a(href="javascript:void(0);" @click="selectFooterSport(57)" :class="menu2 == 7 && $route.name != 'allsports' ? 'active' : ''")
            i.icon-prematch
              img(src='/images/icon-other/v-games.svg?v=12')
            | {{ $t("ui.egames") }}
        li.d-item
          a(href="javascript:void(0);" @click="selectFooterSport(7)" :class="menu2 == 7 && $route.name != 'allsports' ? 'active' : ''")
            i.icon-prematch
              img(:src="'/images/icon-sport-svg/' + getSportsImage(7)")
            | {{ $t("ui.tennis") }}
        li.d-item
          a(href="javascript:void(0);" @click="selectFooterSport(40)" :class="menu2 == 40 && $route.name != 'allsports' ? 'active' : ''")
            i.icon-prematch
              img(:src="'/images/icon-sport-svg/' + getSportsImage(40)")
            | {{ $t("ui.fd") }}
        li.d-item
          a(href="javascript:void(0);" data-toggle='modal' data-target='#allsports')
            i.icon-prematch
              img(src='/images/sport-icon.svg?v=12')
            | {{ $t("ui.all_sports") }}
    router-link#dd-highlight.footer-single(to="/highlight")
      .footer-icon(:class="{ 'active' : $route.name == 'highlight' }")
        i.custom-icon
          img(:src="($route.name == 'highlight') ? '/images/footer_nav/video_hover.svg' : '/images/footer_nav/video.svg'")
        .footer-name {{ $t("ui.video") }}
    //- #dd-euro.footer-single.dropdown
    //-   .dd.footer-icon(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
    //-     .euro24-icon
    //-       img(src='images/euro24-floating-icon.gif')
    //-   ul.dropdown-menu(aria-labelledby='dd-euro' x-placement='bottom-start')
    //-     li.d-item
    //-       a(:href='euroPageUrl' target="_blank")
    //-         img(src='images/euro24-floating-icon-news.png')
    //-     li.d-item
    //-       a(href='javascript:void(0);' @click='setMenu0("2", getEventDate("2024-06-14T21:00:00"))')
    //-         img(src='images/euro24-floating-icon-bet.png')
    #dd-euro.footer-single.dropdown(v-if="isWorldcupEvent")
      .dd.footer-icon(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
        .euro24-icon
          img(src='/images/worldcup.gif')
      ul.dropdown-menu(aria-labelledby='dd-euro' x-placement='bottom-start')
        li.d-item
          a(:href="worldcupPageUrl" target="_blank" rel="noopener")
            img(src='/images/worldcup-floating-icon-news.png')
        li.d-item
          a(href='javascript:void(0);' @click='setMenu0("3", getEventDate("2026-06-11T12:00:00"))')
            img(src='/images/worldcup-floating-icon-bet.png')
    template(v-if="!whiteLabel && !mmoMode && brand != 'UBETT'")
      #dd-my-bets.footer-single
        .dd.footer-icon.ddlive(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false' :class="{ 'active' : ['mybets','my4dbets'].includes($route.name) }")
          i.custom-icon
            img(:src="(['mybets','my4dbets'].includes($route.name)) ? '/images/footer_nav/mybet_hover.svg' : '/images/footer_nav/mybet.svg'")
          .footer-name {{ $t("ui.my_bets") }}
        .dropdown-menu.mybets(aria-labelledby='dd-my-bets' x-placement='bottom-start' style="left: 62% !important;")
          ul.dropdown-item.p-0.m-0
            li
              a(href="javascript:void(0);" @click="go('/mybets')" :class="$route.name == 'mybets' ? 'active' : ''")
                | {{ $t("ui.sportsbook") }}
            li
              a(href="javascript:void(0);" @click="go('/my4dbets')" :class="$route.name == 'my4dbets' ? 'active' : ''")
                | {{ $t("ui.w4d") }}
    template(v-else)
      router-link.footer-single(to="/mybets")
        .footer-icon(:class="{ 'active' : $route.name == 'mybets' }")
          i.custom-icon
            img(:src="($route.name == 'mybets') ? 'images/footer_nav/mybet_hover.svg' : 'images/footer_nav/mybet.svg'")
          .footer-name {{ $t("ui.my_bets") }}
    #dd-account.footer-single.dropdown.dropdown-full
      .dd.footer-icon(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false' :class="{ 'active' : ['account','message','contact_us','statement','result','settings','betting_rules','tnc'].includes($route.name) }")
        i.custom-icon
          img(:src="(['account','message','contact_us','statement','result','settings','betting_rules','tnc'].includes($route.name)) ? '/images/footer_nav/account_hover.svg' : '/images/footer_nav/account.svg'")
        .footer-name {{ $t("ui.account") }}
      .dropdown-menu.account-menu(aria-labelledby='dd-account' x-placement='bottom-start' :class="{ 'apiFooter': whiteLabel }")
        ul
          li.d-item
            router-link(href="javascript:void(0);" to="/account" :class="$route.name == 'account' ? 'active' : ''")
              span.icon
                i.fad.fa-user
              span.text {{ $t("ui.my_account") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/message" :class="$route.name == 'message' ? 'active' : ''")
              span.icon
                i.fad.fa-envelope
              span.text {{ $t("ui.message") }}
          template(v-if="!['MMK','MMO'].includes(currency_code)")
            li.d-item(v-if="!whiteLabel && contact")
              router-link(href="javascript:void(0);" to="/contact_us" :class="$route.name == 'contact_us' ? 'active' : ''")
                span.icon
                  i.fad.fa-phone-volume
                span.text {{ $t("ui.contact_us") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/statement" :class="$route.name == 'statement' ? 'active' : ''")
              span.icon
                i.fad.fa-file-invoice-dollar
              span.text {{ $t("ui.statement") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/sysparlay" :class="$route.name == 'sysparlay' ? 'active' : ''")
              span.icon
                i.fad.fa-file-invoice-dollar
              span.text {{ $t("ui.sysparlay") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/result" :class="$route.name == 'result' ? 'active' : ''")
              span.icon
                i.fad.fa-chart-bar
              span.text {{ $t("ui.result") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/parlaygenerator" :class="$route.name == 'parlaygenerator' ? 'active' : ''")
              span.icon
                i.fad.fa-random
              span.text {{ $t("ui.parlay_generator") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/settings" :class="$route.name == 'settings' ? 'active' : ''")
              span.icon
                i.fad.fa-cog
              span.text {{ $t("ui.settings") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/betting_rules" :class="$route.name == 'betting_rules' ? 'active' : ''")
              span.icon
                i.fad.fa-file-alt
              span.text {{ $t("ui.betting_rules") }}
          li.d-item
            router-link(href="javascript:void(0);" to="/tnc" :class="$route.name == 'tnc' ? 'active' : ''")
              span.icon
                i.fad.fa-tasks
              span.text {{ $t("ui.tnc") }}
          li.d-item(v-if="brand != 'FOTBET'")
            a(href="https://docs.google.com/forms/d/16N4aJg8nc2c3yqiAMG1byLhbmUnyfaG74_BABeo-2aY/viewform?edit_requested=true" target="_blank")
              span.icon
                img.feedback(:src="'/images/feedback-icon.png'")
              span.text.text-white {{ $t("ui.feedback") }}
        .btn-logout-wrap(v-if="!whiteLabel")
          a.btn-logout(href="javascript:void(0);" @click="logout()")
            span.icon.mr-1
              i.fad.fa-sign-out-alt
            span.text {{ $t("ui.logout") }}
        .footer-group
          .footer-wrapper
            .footer-item.select-lang(data-toggle='modal' data-target='#changeLang')
              span.icon.lang-pic
                img(:src="'/images/lang/' + language +  '.svg?v=12'")
              span.text-light {{ $t("language." + language) }}
            .footer-item(v-if="!whiteLabel")
              a(:href="desktopUrl")
                span.icon
                  i.fad.fa-desktop
                span.text-light {{ $t("ui.desktop_view") }}
            .footer-item(v-else)
              a(href="javascript:void(0);" @click='changeView("modern")')
                span.icon.lang-pic
                  img(src='images/sparkles.svg')
                span.text-light {{ $t("ui.modern_view") }} 
            .footer-item(v-if="contact")
              a(href="https://www.facebook.com/WbetOfficial/?epa=SEARCH_BOX" target="_blank")
                span.icon
                  i.fab.fa-facebook-square
                span.text-light {{ brand }}

</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import xhr from "@/library/_xhr-menu";
import sync from "@/library/_sync-menu";
import calc from "@/library/_calculation";
import config from "@/config";
import acc from '@/library/_xhr-account';

export default {
  data() {
    return {
      options: {},
      total_bet: 1,
      total_stake: 0,
      fold: 0,
      firstLoad: true,
      menuLoading: false,
      menuPollTimer: null,
      // Must match drawer SPECIAL_EVENTS[2] (worldcup) — [copa, euro, WORLDCUP, ...]
      // SPECIAL_EVENTS: [0, 0, 1, 0, 0, 0, 0, 0]
    };  
  },
  computed: {
    SPECIAL_EVENTS() {
      return [0, 0, this.wcMode ? 1 : 0, 0, 0, 0, 0, 0];
    },
    wcMode() {
      return config.wcMode;
    },
    isWorldcupEvent() {
      return !!this.SPECIAL_EVENTS[2];
    },
    worldcupPageUrl() {
      const domain = config.getDomain(window.location.hostname, false);
      return "https://wbetwc.com?referer=m." + domain;
    },
    euroPageUrl() {
      return config.getEuroPageUrl();
    },
    contact() {
      return config.contact;
    },
    brand() {
      return config.brand;
    },
    esports2() {
      return config.esports2 == "1";
    },
    menuX() {
      return this.$store.getters.menuX;
    },
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    combo() {
      return this.$store.state.betparlay.combo;
    },
    comboKeys() {
      return Object.keys(this.$store.state.betparlay.combo);
    },
    comboOdds() {
      var results = {};
      var nn = 0;
      for (var n in this.comboKeys) {
        for (var m in this.combo[this.comboKeys[n]]) {
          nn = nn + 1;
          if (results[this.comboKeys[n]] == null) {
            results[this.comboKeys[n]] = [];
          }
          var multi = 1.0;
          var po = -1;
          for (var j in this.combo[this.comboKeys[n]][m]) {
            var test = this.$store.state.betparlay.data[this.combo[this.comboKeys[n]][m][j]];
            if (test != null) {
              multi = multi * parseFloat(test.val);
              var mpo = test.maxParlayPayout;
              if (po < 0 || po > mpo) po = mpo;
            }
          }
          // multi = multi.toFixed(3);
          results[this.comboKeys[n]].push([multi, po + nn]);
        }
      }
      return results;
    },
    betparlay() {
      return this.$store.state.betparlay;
    },
    betparlaymmo() {
      return this.$store.state.betparlaymmo;
    },
    betparlayCount() {
      if(this.menuX && this.mmoMode) {
        return Object.keys(this.$store.state.betparlaymmo.data).length;
      } else {
        return Object.keys(this.$store.state.betparlay.data).length;
      }
    },
    multi() {
      var result = 1;
      if(this.menuX && this.mmoMode) {
        for (var n in this.betparlaymmo) {
          result = result * 2;
        }
      } else {
        // for (var n in this.betparlay) {
        //   result = result * parseFloat(this.betparlay[n].val);
        // }
        var result = 0.0;
        if (this.comboOdds.hasOwnProperty(this.betparlayCount)) {
          for (var n in this.comboOdds[this.betparlayCount]) {
            result = result + this.comboOdds[this.betparlayCount][n][0];
          }
        }
      }

      var f = result ? parseFloat(calc.fm(result, false, 4)).toFixed(3) : 0;
      return f;
    },
    desktopUrl() {
      let domain = window.location.hostname;
      let sessionToken = this.$store.getters.sessionToken;
      return "https://" + domain.replace("m.", "") + "?&u=" + this.account_id + "&st=" + sessionToken;
    },
    menuList() {
      return this.$store.state.layout.menuList;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    account_id() {
      return this.$store.getters.accountId;
    },
    nickname() {
      return this.$store.getters.nickName;
    },
    last_login_time() {
      if (this.$store.getters.playerInfo) return this.$dayjs(this.$store.getters.playerInfo.last_login_time).format("MM/DD/YY hh:mm:ss A");
      return null;
    },
    wallet() {
      if (this.$store.getters.playerWallet) return this.$store.getters.playerWallet;
      return null;
    },
    balance() {
      return this.$store.getters.balance;
    },
    currency_code() {
      if (this.wallet["currency_code"]) {
        return this.wallet.currency_code;
      }
      return "-";
    },
    available_balance() {
      if (this.wallet) {
        return this.$numeral(this.balance).format("0,0.[00]");
      }
      return "-";
    },
    cash_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.cash_balance).format("0,0.[00]");
      }
      return "-";
    },
    frozen_balance() {
      if (this.wallet) {
        return this.$numeral(this.wallet.frozen_balance).format("0,0.[00]");
      }
      return "-";
    },
    given_credit() {
      if (this.wallet) {
        return this.$numeral(this.wallet.credit_limit).format("0,0.[00]");
      }
      return "-";
    },
    selectedDays() {
      return this.$store.getters.selectedDays;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    language() {
      return this.$store.getters.language;
    }
  },
  watch: {
    language() {
      this.populateMenu(null, true);
    }
  },
  destroyed() {
    EventBus.$off("GET_BALANCE", this.onBalanceRefreshMenu);
    this.stopMenuPolling();
  },
  mounted() {
    this.startMenuPolling();
    EventBus.$on("GET_BALANCE", this.onBalanceRefreshMenu);
    $(".dd").dropdown();
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    showMe() {
      if(this.menuX && this.mmoMode) {
        if (EventBus.showParlayMMO) {
          EventBus.showParlayMMO();
        }
      } else {
        if (EventBus.showParlay) {
          EventBus.showParlay();
        }
      }
    },
    go(e) {
      this.$router.push(e).catch(err => {});
    },
    logout() {
      this.$helpers.logout();
    },
    getMenu(e) {
      if (!this.menuList) {
        return {};
      }

      if (!this.menuList.menu) {
        return {};
      }

      switch (e) {
        case "early":
          if (this.menuList.menu["1"]) return this.menuList.menu["1"];
          else return {};
        case "today":
          if (this.menuList.menu["2"]) return this.menuList.menu["2"];
          else return {};
        case "live":
          if (this.menuList.menu["3"]) return this.menuList.menu["3"];
          else return {};
        case "parlay":
          if (this.menuList.menu["4"]) return this.menuList.menu["4"];
          else return {};
        default:
          return {};
      }
    },
    setDays(e) {
      if (config.day1.includes(e)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }
    },
    hasSportMarket(marketId, sportId) {
      var menu = this.menuList && this.menuList.menu && this.menuList.menu[marketId];
      var item = menu && (menu[sportId] || menu[String(sportId)]);
      return !!(item && item.tn > 0);
    },
    selectFooterSport(sportId) {
      if (this.menu0 == "parlay") {
        this.setMenu2x("today", sportId);
        return;
      }
      // V-Games only render the egames template on all/today. A live count would
      // otherwise send bomberman into the normal live list, unlike drawer.vue.
      if (config.gamesList.includes(String(sportId))) {
        this.setMenu2x("today", sportId);
        return;
      }
      if (this.hasSportMarket("3", sportId)) {
        this.setMenu2x("live", sportId);
      } else if (this.hasSportMarket("2", sportId)) {
        this.setMenu2x("today", sportId);
      } else if (this.hasSportMarket("1", sportId)) {
        this.setMenu2x("early", sportId);
      } else {
        this.setMenu2x("today", sportId);
      }
    },
    setMenu2x(m, e) {
      // $(".btn-parlay").removeClass("active");
      this.$store.dispatch("layout/setSelectedMatch", null);
      // this.$store.dispatch("layout/resetSelectLeague"); 
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      switch (m) {
        case "live":
          mi5["menu1"] = "live";
          mi5["menu3"] = "hdpou";
          mi5["menu0"] = "live";
          mi5["menu2"] = parseInt(e != null ? e : this.menu2);
          var liveOptions = {};
          liveOptions[mi5["menu2"]] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: liveOptions });
          break;
        case "upcoming":
          $(".ddlive").dropdown("toggle");
          mi5["menu1"] = m;
          mi5["menu3"] = "hdpou";
          mi5["menu0"] = "upcoming";
          mi5["menu2"] = parseInt(this.menu2);
          for (var n in this.options) {
            this.options[n] = false;
          }
          this.options[parseInt(this.menu2)] = true;
          this.$store.dispatch("layout/setOptions", { property: "live", value: this.options });
          break;
        default:
          if (this.menu0 == "parlay") {
            mi5["menu1"] = "parlay";
            mi5["menu3"] = "parlay";
            mi5["menu0"] = "parlay";
          } else {
            mi5["menu1"] = m;
            mi5["menu3"] = "hdpou";
            mi5["menu0"] = "all";
          }

          mi5["menu2"] = parseInt(e);
      }

      config.applyWeekendTodayMarket(mi5, this.$dayjs().day(), this.$store);

      var changed = false;
      if (mi5["menuX"] != this.menuX) {
        changed = true;
      }
      if (mi5["menu0"] != this.menu0) {
        changed = true;
      }
      if (mi5["menu1"] != this.menu1) {
        changed = true;
      }
      if (mi5["menu2"] != this.menu2) {
        changed = true;
      }
      if (mi5["menu3"] != this.menu3) {
        changed = true;
      }
      if (changed) {
        this.setDays(parseInt(mi5["menu2"]));
        this.resetSelectLeague();
        this.clearSearch();
        this.$store.dispatch("layout/setMenuItems", mi5);
        if (this.$route.name == "prematch") {
          EventBus.$emit("INVALIDATE", mi5);
        }
      }
      if(m == 'livenow') {
        this.$router.push("/highlight").catch(err => {});
      } else {
        this.$router.push("/prematch").catch(err => {});
      }
    },
    clearSearch() {
      this.$store.dispatch("layout/setSearch", null);
    },
    resetSelectLeague() {
      var elem = $(".btn-collapse");
      if (elem.hasClass("close-all")) {
        elem.removeClass("close-all");
        elem.addClass("open-all");
      }
      this.$store.dispatch("layout/resetSelectLeague");
    },
    startMenuPolling() {
      this.stopMenuPolling();
      this.populateMenu();
      this.menuPollTimer = setInterval(() => {
        this.populateMenu();
      }, 15000);
    },
    stopMenuPolling() {
      if (this.menuPollTimer != null) {
        clearInterval(this.menuPollTimer);
        this.menuPollTimer = null;
      }
    },
    onBalanceRefreshMenu() {
      this.populateMenu(null, true);
    },
    populateMenu(callback, force) {
      if (this.menuLoading && !force) {
        return;
      }
      if (this.isLoggedIn) {
        this.menuLoading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          arguments: [this.$store.getters.language]
        };
        xhr.getMenu(args, { force: !!force }).then(
          res => {
            this.menuLoading = false;
            if (res.skipped) {
              if (callback) {
                callback();
              }
              return;
            }
            if (res.success) {
              if (res.data) {
                var m = sync.decode(res.data);
                this.$store.dispatch("layout/setSports", { items: m["sports"], currency_code: this.currency_code });
                this.$store.dispatch("layout/setMenuList", m);
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                // if (callback) callback();
              }
            }

            var q = this.$route.query;
            if (q.vg == 1) {
              this.setMarbleRunView();
            }
          },
          err => {
            this.menuLoading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              // if (callback) callback();
            }
          }
        );
      }
    },
    setMarbleRunView() {
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu2"] = 49;
      mi5["menu3"] = "hdpou";

      var options = {};
      options[mi5["menu2"]] = true;
      this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE");
      this.$router.push("/prematch");
    },
    setMenu0(e, m, bt) {
      if (EventBus.setMenu0) {
        if(bt == 'orz') {
          EventBus.setMenu0('event', e, m, bt);
        } else {
          EventBus.setMenu0('event', e, m);
        }
      }
    },
    getEventDate(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? "today" : "early";
    },
    getEventDate2(e) {
      var d1 = new Date();
      var d2 = new Date(e);
      return d1 >= d2 ? null : "orz";
    },
    changeView(e) {
      let wloc = acc.changeView(e);
      const modernParam = e === "modern" ? "&v=m" : "";
      window.location.href = wloc+ "?u=" + this.$store.getters.accountId + "&st=" + this.$store.getters.sessionToken + modernParam;
    }
  }
};
</script>
